import { apiClient } from 'api/apiClient';
import { BrandModel, BrandSchema, BrandType, WhiteLabelAsset } from './schema';
import { defaultBrand, hasWLAccess, subDomain } from './utils';

export const getBrandFromS3 = async (): Promise<BrandType | null> => {
  try {
    if (!hasWLAccess) return null;

    let url = '';
    if (window.location.hostname === 'localhost') {
      url = 'http://localhost:9000/frontend';
    }

    const res = await fetch(`${url}/whitelabel/${subDomain}.json`);

    if (!res.ok) {
      console.error(`File ${subDomain}.json not found (status ${res.status})`);
      return defaultBrand;
    }

    const contentType = res.headers.get('content-type');
    if (!contentType?.includes('application/json')) {
      console.error(`${subDomain}.json is not JSON (got ${contentType})`);
      return defaultBrand;
    }

    const json = await res.json();
    return BrandSchema.parse(json);
  } catch (err) {
    console.error(`Failed to fetch brand config for ${subDomain}:`, err);
    return defaultBrand;
  }
};

export const uploadWhiteLabelAssets = async (
  data: FormData,
): Promise<WhiteLabelAsset> => {
  const response = await apiClient.post(`/api/v1/whitelabel/assets`, data, {
    headers: {
      'Content-type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteWhiteLabelAsset = async (id: string) => {
  const response = await apiClient.delete(`/api/v1/whitelabel/assets/${id}`);
  return response.data;
};

export const getBrand = async (): Promise<BrandModel | undefined> => {
  const response = await apiClient.get('/api/v1/whitelabel/configs');
  return response.data[0] ?? undefined;
};

export const postBrand = async (data: BrandModel): Promise<BrandModel> => {
  const response = await apiClient.post('/api/v1/whitelabel/configs', data);
  return response.data;
};

export const putBrand = async (data: BrandModel): Promise<BrandModel> => {
  const response = await apiClient.put('/api/v1/whitelabel/configs', data);
  return response.data;
};

export const deleteBrand = async (id: string) => {
  const response = await apiClient.delete(`/api/v1/whitelabel/configs/${id}`);
  return response.data;
};
